const fileTypes = '.jpeg, .jpg, .png, .txt, .doc, .docx, .xls, .xlsx, .pdf, .csv';
export default fileTypes;
